import React from "react";
import PropTypes from "prop-types";
import { usePermissions } from "../user/permissions";
import useOrganizationContext from "../../hooks/useOrganizationContext";
import UnauthorizedPage from "../../pages/error/unauthorized-page";

const CapacityMiddleware = ({
	children,
	required = null,
	oneOf = null,
	backHomeUrl = null
}) => {
	const permissions = usePermissions();
	const organization = useOrganizationContext();

	const organizationId = organization?.id();

	const hasAccess = React.useMemo(() => {
		if (!organizationId || !permissions) {
			return true;
		}

		if (required && Array.isArray(required) && required.length > 0) {
			return required.every(capacity =>
				permissions.hasCapacity(capacity, organizationId)
			);
		}

		if (oneOf && Array.isArray(oneOf) && oneOf.length > 0) {
			return permissions.hasCapacities(oneOf, organizationId);
		}

		const userCapacities = permissions.capacityOrga(organizationId);
		return userCapacities.size > 0;
	}, [permissions, organizationId, required, oneOf]);

	const defaultBackHomeUrl = React.useMemo(() => {
		if (backHomeUrl) {
			return backHomeUrl;
		}
		if (organizationId) {
			return `/access/O${organizationId}/checkpoints`;
		}
		return null;
	}, [backHomeUrl, organizationId]);

	if (!organizationId || !permissions) {
		return <>{children}</>;
	}

	if (!hasAccess) {
		return <UnauthorizedPage backHomeUrl={defaultBackHomeUrl} />;
	}

	return <>{children}</>;
};

CapacityMiddleware.propTypes = {
	children: PropTypes.node.isRequired,
	required: PropTypes.arrayOf(PropTypes.string),
	oneOf: PropTypes.arrayOf(PropTypes.string),
	backHomeUrl: PropTypes.string
};

export default CapacityMiddleware;
